import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import { generateSrcSet } from 'project/image-proxy-web'
import FeatureItem from 'components/FeatureItem'
import RegulatoryRatings from 'components/RegulatoryRatings'
const features = [
  {
    description:
      'We strictly comply with KYC/AML policies, enforced by a dedicated Compliance team. We are regulated as a Trust and Service Provider by the HMRC (AML no.12883542).',
    title: 'Regulatory compliance.',
  },
  {
    description:
      'A proven track record of successful collaborations with prominent banks such as Tide, ANNA, and other fintech partners. Not to mention our accounting partnerships. All in all, we have securely serviced over 60,000 SMEs without incident.',
    title: 'Fintech partnership.',
  },
  {
    description:
      'We are audited regularly, maintain certifications, provide industry-standard protections (ICO no. ZA041914).',
    title: 'Data Protection.',
  },
  {
    description:
      'Our Cyber Essentials and Cyber Essentials Plus certifications highlight our commitment to cybersecurity.',
    title: 'Uncompromised Security.',
  },
  {
    description:
      'Ready to provide Sample Commercial agreement, T&Cs, Business Continuity Plan, Data protection policies, Customer Support SLA, Complaints Policy, Service Level Agreement, and Proof of ID and address document checklist.',
    title: 'Transparency & Accountability.',
  },
]

type RegulatoryComplianceCardType = {
  className?: string
}

const RegulatoryComplianceCard: ReactFC<
  PropsWithChildren<RegulatoryComplianceCardType>
> = ({ className = '' }) => {
  return (
    <div>
      <div className='row px-2 px-lg-0'>
        <div className='col-12 mt-0 col-lg-6 d-flex flex-column position-relative'>
          <img
            {...generateSrcSet('/images/new/cool-robot-with-tie.png', 551, 737)}
            loading='lazy'
            alt='HaiRo™ robot mascot with cool stickers holding tie'
            className='rounded-img position-absolute h-100 object-fit-contain'
            style={{
              maxWidth: '100%',
            }}
          />
        </div>
        <div className='col-12 mt-0 pt-8 pt-lg-11 g-3 g-lg-4 col-lg-6'>
          <div className='ps-4 ps-lg-20 pb-5 pb-lg-17 pe-4 pe-lg-0'>
            <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
              {features.map((feature) => (
                <FeatureItem
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
            <RegulatoryRatings />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegulatoryComplianceCard
